/**
 * Shared React Query cache keys — the single source of truth for keys used by
 * more than one module, so an invalidation in one screen reliably refreshes
 * every other consumer (a typo'd literal would silently leave a list stale).
 *
 * Only CROSS-FILE keys belong here; a key consumed by exactly one component
 * stays module-private in that component until a second consumer appears.
 */

/** The Knowledge Base document list (DocumentList + approval decisions). */
export const DOCUMENTS_QUERY_KEY = ['documents'] as const;

/**
 * The caller's decidable queue of pending access-graph changes — grants they
 * own and publishes they approve, in ONE cache entry because the backend
 * serves them as one collection. There used to be a second key here for a
 * second endpoint; both are gone with the endpoint.
 */
export const ACCESS_INBOX_QUERY_KEY = ['access-requests', 'inbox'] as const;
